import script from "./AppSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSelect.vue?vue&type=script&lang=ts&setup=true"

import "./AppSelect.vue?vue&type=style&index=0&id=cdd1dfce&lang=scss"

const __exports__ = script;

export default __exports__